<template>
  <b-container class="text-left" v-html="$t('privacy-policy-professional.text', PRIVACY_POLICY_COMPANY_DATA)">
  </b-container>
</template>

<script>
import es from '@/lang/es/public/views/privacy-policy-professional.json'
import en from '@/lang/en/public/views/privacy-policy-professional.json'
import pt from '@/lang/pt/public/views/privacy-policy-professional.json'
import mx from '@/lang/mx/public/views/privacy-policy-professional.json'
import { PRIVACY_POLICY_COMPANY_DATA } from '@/constants/companyCommonData'

export default {
	i18n: {
		messages: {
			es,
			en,
			pt,
			mx
		}
	},
	data () {
		return {
			PRIVACY_POLICY_COMPANY_DATA
		}
	}
}
</script>

<style lang="scss" scoped>
	/deep/ li {
		list-style: inherit !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/PrivacyPolicyProfessional.vue